import React from 'react';

import SummaryTile from './SummaryTile';

import styles from './SummaryTiles.scss';

export type Section = {
  isCompleted?: boolean;
  isDependencyCompleted?: boolean;
  isReactivated?: boolean;
  label: React.ReactNode;
  node?: string;
  path?: string;
  requiresAction?: boolean;
  status?: string;
}

type SummaryTilesProps = {
  onClick?: () => void | undefined;
  sections: Section[];
}

const SummaryTiles = ({
  onClick,
  sections,
}: SummaryTilesProps) => <div className={styles.summaryTiles}>
  {sections.map((section) =>
    <SummaryTile
      {...{ onClick }}
      key={section.label as string}
      isCompleted={section.isCompleted}
      isDependencyCompleted={section.isDependencyCompleted}
      isReactivated={section.isReactivated}
      label={section.label as string}
      path={section.path}
      status={section.status}
    />)}
</div>;

export default SummaryTiles;
